import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as api from '../../../api';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import { Link } from 'react-router-dom';
import { getEventDesignerDisplayName } from '../../../Components/AdminPanels/utils/eventDesignerHelpers';
import FabFrIndicator from '../../Atoms/FabFrIndicator';
import { FD100MultiSelectOptions } from '../../Utils/Listings';
import { supabase } from '../../../lib/supabaseClient';

const Container = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
`;

const ProjectGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 25px;
    margin-top: 30px;
`;

const ProjectCard = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    background: white;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    position: relative;
    overflow: hidden;

    &:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
        border-color: #2196f3;
    }
`;

const ProjectImage = styled.div`
    width: 100%;
    height: 220px;
    background-size: cover;
    background-position: center;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 18px;
    border: 1px solid #eee;
`;

const ProjectName = styled.h3`
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const DesignerName = styled.p`
    margin: 0 0 16px 0;
    color: #666;
    font-size: 15px;
    font-weight: 500;
`;

const ViewButton = styled(Link)`
    display: inline-block;
    padding: 12px 20px;
    background: linear-gradient(135deg, #2196f3, #1976d2);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);

    &:hover {
        background: linear-gradient(135deg, #1976d2, #1565c0);
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
    }

    &:visited {
        color: white;
    }
`;

const CategoryBadge = styled.span`
    display: inline-block;
    padding: 6px 12px;
    background: linear-gradient(135deg, #e3f2fd, #bbdefb);
    border: 1px solid #2196f3;
    color: #1976d2;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 12px;
`;

const StatusBadge = styled.span`
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 10px;
    background: ${props => {
        if (props.status === 'validé') return '#4caf50';
        if (props.status === 'refusé') return '#f44336';
        return '#ff9800';
    }};
    color: white;
`;

const SpecialAwardBadge = styled.div`
    position: absolute;
    top: -40px;
    right: -20px;
    background: linear-gradient(135deg, #ffffffff, #717171ff);
    color: black;
    border-radius: 100px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 10;
    text-transform: uppercase;
    width: 120px;
    height: 120px;
    text-align: center;
`;


const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
`;

const ProjectCardWrapper = styled.div`
    position: relative;
`;

const PageTitle = styled.h1`
    text-align: center;
    font-size: 36px;
    font-weight: 800;
    margin: 40px 0 20px 0;
    text-transform: none;
`;

const PageSubtitle = styled.h2`
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 80px 0;
    color: #666;
`;

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc',
    '67a0b8331b103d938bafa954',
    '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c',
    '67e6c18043d5609350e381a8',
    '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73',
    '67bf2330b1ba28c3144af8d2',
    '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63',
    '67c6b416db48cb16a13c73c7',
    '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c',
    '67d15108d95ccf24eaf191df',
    '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e',
    '662adc507159e5b1b1da7c75',
    '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2',
    '682b5c5f754f51df2ef93bbc',
    '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb',
    '67daebf343d5609350e27a9e',
    '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360',
    '67e1452a43d5609350e2b066',
    '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97',
    '67e3e1cb43d5609350e304e5',
    '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a',
    '67e42d7043d5609350e32539',
    '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0',
    '67e529f743d5609350e33a8c',
    '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f',
    '67e5764d43d5609350e34cb5',
    '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3',
    '67e58da443d5609350e3561d',
    '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905',
    '67e6828d43d5609350e36b6a',
    '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667',
    '67e6c0a843d5609350e380cf',
    '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900',
    '67e7003c43d5609350e38bfc',
    '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae',
    '67f90250a0262e085d37088f',
    '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e',
    '67ab6ade07736060460b3c16',
    '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d',
    '6800b8529167c049fff50e47',
    '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f',
    '6800fad59167c049fff52224',
    '680113739167c049fff52d73',
    '680106139167c049fff525af',
    '680125219167c049fff53405',
    '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e',
    '68020ef79167c049fff54015',
    '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7',
    '680249249167c049fff55a19',
    '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037',
    '680270379167c049fff566f5',
    '680274c09167c049fff567c8',
    '680275419167c049fff567de',
    '68027b389167c049fff56954',
    '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f',
    '6849787b17dde4ca4c4bf043',
    '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4',
    '6808c3f59167c049fff599c7',
    '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee',
    '6801e2f49167c049fff53ce1',
    '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49',
    '6810df4a264e7745556ad75d',
    '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977',
    '680fa9f09167c049fff5e027',
    '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62',
    '6818cac19e656d77bc6c72fa',
    '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0',
    '682d97b2754f51df2ef96070',
    '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const FD10025Winners = () => {
    const { i18n } = useTranslation('common');
    const [allProjects, setAllProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [definitiveNames, setDefinitiveNames] = useState({});

    // Hardcoded event ID for FD100 2025
    const eventId = '67590da5499bcc995c210b40';

    // Create categories mapping like in FDProjetsList.js
    const tyoplogieEspaceFD100Fr = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");
    const typologieObjetFD100Fr = FD100MultiSelectOptions.typologieObjetFD100("fr");
    const tyoplogieEspaceFD100En = FD100MultiSelectOptions.tyoplogieEspaceFD100("en");
    const typologieObjetFD100En = FD100MultiSelectOptions.typologieObjetFD100("en");

    // Merge categories and remove duplicates for French
    const FDCategoriesFr = [
        ...tyoplogieEspaceFD100Fr,
        ...typologieObjetFD100Fr,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);

    // Merge categories and remove duplicates for English
    const FDCategoriesEn = [
        ...tyoplogieEspaceFD100En,
        ...typologieObjetFD100En,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);

    // Helper function to get translated category label from code (French)
    const getCategoryLabel = (categoryCode) => {
        if (!categoryCode) return i18n.language === 'fr' ? 'Sans catégorie' : 'Uncategorized';
        const categories = i18n.language === 'fr' ? FDCategoriesFr : FDCategoriesEn;
        const category = categories.find(cat => cat.value === categoryCode);
        return category ? category.label : categoryCode;
    };

    // Fetch definitive project names from Supabase
    useEffect(() => {
        const fetchDefinitiveNames = async () => {
            const { data: projectNamesData } = await supabase
                .from('fd100_project_names')
                .select('*')
                .eq('event_id', eventId);

            const namesMap = {};
            if (projectNamesData) {
                projectNamesData.forEach(item => {
                    namesMap[item.project_id] = {
                        name_fr: item.name_definitive_fr,
                        name_en: item.name_definitive_en,
                        designer: item.designer_definitive,
                        typology_fr: item.typology_fr,
                        typology_en: item.typology_en
                    };
                });
            }
            setDefinitiveNames(namesMap);
        };
        fetchDefinitiveNames();
    }, [eventId]);

    // Fetch winner projects using the lighter endpoint (no HubSpot dependency)
    useEffect(() => {
        setLoading(true);
        api.getParticipatingUsersProjectData({ eventId: eventId, winnerProjectIds: WINNER_PROJECT_IDS, fullProjectData: true }).then((response) => {
            let _allProjects = [];
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company?.projects?.find((projet) => projet._id === project_id);
                        if (project && project.status === "validé" && WINNER_PROJECT_IDS.includes(project._id)) {
                            _allProjects.push({
                                projet: { ...project, participationId: user.participation._id },
                                user: user
                            });
                        }
                    });
                }
            });
            setAllProjects(_allProjects);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
        });
    }, [eventId]);

    const getProjectImage = (project) => {
        if (project.medias && project.medias.length > 0) {
            const firstMedia = project.medias[0];
            if (firstMedia.type.includes('image')) {
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + firstMedia.path;
            } else if (firstMedia.type.includes('pdf')) {
                const filename = firstMedia.path.split('/').pop();
                const pdfPreviewPath = firstMedia.path.replace(filename, "firstpage_" + filename).replace('.pdf', '.png');
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + pdfPreviewPath;
            }
        }
        return null;
    };

    const hasFabricationFrancaise = (project) => {
        return project.projet.fabrication_fr === "oui";
    };

    // Get definitive project name (falls back to original if not found)
    const getDefinitiveProjectName = (project) => {
        const definitive = definitiveNames[project.projet._id];
        if (definitive) {
            if (i18n.language === 'fr') {
                return definitive.name_fr || project.projet.name;
            } else {
                return definitive.name_en || definitive.name_fr || project.projet.name_en || project.projet.name;
            }
        }
        return i18n.language !== 'fr' && project.projet.name_en ? project.projet.name_en : project.projet.name;
    };

    // Get definitive designer name (falls back to original if not found)
    const getDefinitiveDesignerName = (project) => {
        const definitive = definitiveNames[project.projet._id];
        if (definitive && definitive.designer) {
            return definitive.designer;
        }
        return getEventDesignerDisplayName(project.projet, project.user);
    };

    // Define the special award winners
    const GRAND_PRIX_ID = '68025b1a9167c049fff56037';
    const MENTION_DESIGN_ID = '6808c3859167c049fff599b1';
    const COUP_DE_COEUR_ID = '67e5864c43d5609350e353a3';

    // Separate special winners from the rest
    const grandPrixProject = allProjects.find(p => p.projet._id === GRAND_PRIX_ID);
    const mentionDesignProject = allProjects.find(p => p.projet._id === MENTION_DESIGN_ID);
    const coupDeCoeurProject = allProjects.find(p => p.projet._id === COUP_DE_COEUR_ID);

    // Get remaining projects (excluding the 3 special ones)
    const remainingProjects = allProjects.filter(p =>
        p.projet._id !== GRAND_PRIX_ID &&
        p.projet._id !== MENTION_DESIGN_ID &&
        p.projet._id !== COUP_DE_COEUR_ID
    );

    // Sort remaining projects alphabetically by designer name
    const sortedRemainingProjects = [...remainingProjects].sort((a, b) => {
        const nameA = getDefinitiveDesignerName(a).toLowerCase();
        const nameB = getDefinitiveDesignerName(b).toLowerCase();
        return nameA.localeCompare(nameB);
    });

    // Combine special winners first, then alphabetically sorted rest
    const sortedProjects = [
        ...(grandPrixProject ? [grandPrixProject] : []),
        ...(mentionDesignProject ? [mentionDesignProject] : []),
        ...(coupDeCoeurProject ? [coupDeCoeurProject] : []),
        ...sortedRemainingProjects
    ];

    // // CSV Export of all fabricants
    // const fabricantsData = [];

    // allProjects.forEach(p => {
    //     const projectName = p.projet.name;
    //     const designerName = getEventDesignerDisplayName(p.projet, p.user);
    //     const hasFabFr = hasFabricationFrancaise(p);

    //     // Get additional project data
    //     const galerie = p.projet.editeur || '';
    //     const distributeur = p.projet.distributeur || '';
    //     const adresse = p.projet.adresse || '';

    //     try {
    //         const fabricants = JSON.parse(p.projet.fabricants);
    //         fabricants.forEach(f => {
    //             fabricantsData.push({
    //                 'Nom du projet': projectName,
    //                 'Nom du designer': designerName,
    //                 'Fabrication française': hasFabFr ? 'Oui' : 'Non',
    //                 'Galerie': galerie,
    //                 'Distributeur': distributeur,
    //                 'Adresse': adresse,
    //                 'Nom du fabricant': f.name || '',
    //                 'Contact du fabricant': f.contact || '',
    //                 'Email du fabricant': f.email || '',
    //                 'Travail effectué': f.work || ''
    //             });
    //         });
    //     } catch (e) {
    //         console.log(`Erreur de parsing des fabricants pour le projet ${projectName}:`, e);
    //         // Still add a row with empty fabricant info
    //         fabricantsData.push({
    //             'Nom du projet': projectName,
    //             'Nom du designer': designerName,
    //             'Fabrication française': hasFabFr ? 'Oui' : 'Non',
    //             'Galerie': galerie,
    //             'Distributeur': distributeur,
    //             'Adresse': adresse,
    //             'Nom du fabricant': '',
    //             'Contact du fabricant': '',
    //             'Email du fabricant': '',
    //             'Travail effectué': ''
    //         });
    //     }
    // });

    // // Generate and download CSV
    // if (fabricantsData.length > 0) {
    //     const csv = Papa.unparse(fabricantsData);
    //     const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    //     const link = document.createElement('a');
    //     const url = URL.createObjectURL(blob);
    //     link.setAttribute('href', url);
    //     link.setAttribute('download', `fabricants_fd100_2025_${new Date().toISOString().split('T')[0]}.csv`);
    //     link.style.visibility = 'hidden';
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);

    //     console.log(`CSV exporté avec ${fabricantsData.length} lignes de fabricants`);
    // }
    // // End of fabricants CSV export

    if (loading) {
        return <Spinner />;
    }

    return (
        <>
        <Container>
            <PageTitle>
                {i18n.language === 'fr' ? 'Le FD100 - 4ème édition' : 'Le FD100 - 4th Edition'}
            </PageTitle>
            <PageSubtitle>
                {i18n.language === 'fr' ? 'Sélection Finale' : 'Final Selection'}
            </PageSubtitle>
            <ProjectGrid>
                {sortedProjects.map((project, index) => {
                    // Determine if this project has a special award
                    let specialAwardLabel = null;
                    if (project.projet._id === GRAND_PRIX_ID) {
                        specialAwardLabel = i18n.language === 'fr' ? 'Grand Prix' : 'Grand Prize';
                    } else if (project.projet._id === MENTION_DESIGN_ID) {
                        specialAwardLabel = i18n.language === 'fr' ? 'Mention Spéciale Design' : 'Special Design Mention';
                    } else if (project.projet._id === COUP_DE_COEUR_ID) {
                        specialAwardLabel = i18n.language === 'fr' ? 'Top Coup de Cœur' : 'Top Coup de Cœur';
                    }

                    return (
                        <ProjectCardWrapper key={project.projet._id}>
                            {specialAwardLabel && (
                                <SpecialAwardBadge>{specialAwardLabel}</SpecialAwardBadge>
                            )}
                            <ProjectCard>
                            <ProjectImage style={{
                                backgroundImage: getProjectImage(project.projet) ? `url(${getProjectImage(project.projet)})` : 'none'
                            }} />
                            <CategoryBadge>{getCategoryLabel(project.projet.typologie)}</CategoryBadge>
                            {project.projet.statusFinal && (
                                <StatusBadge status={project.projet.statusFinal}>
                                    {project.projet.statusFinal}
                                </StatusBadge>
                            )}
                            <ProjectName>
                                <span>{getDefinitiveProjectName(project)}</span>
                                {hasFabricationFrancaise(project) && <FabFrIndicator />}
                            </ProjectName>
                            <DesignerName>{getDefinitiveDesignerName(project)}</DesignerName>
                            <ButtonContainer>
                                <ViewButton
                                    to={`/admin/events/fdficheprojet?email=${project.user.user.email}&pid=${project.user.participation._id}&projid=${project.projet._id}`}
                                    target="_blank"
                                >
                                    {i18n.language === 'fr' ? 'Voir la fiche projet' : 'View project details'}
                                </ViewButton>
                                {project.user.company && (
                                    <ViewButton
                                        style={{background: 'linear-gradient(135deg, #6c757d, #495057)'}}
                                        to={`/company?id=${project.user.company._id}`}
                                        target="_blank"
                                    >
                                        {i18n.language === 'fr' ? 'Fiche agence' : 'Agency profile'}
                                    </ViewButton>
                                )}
                            </ButtonContainer>
                            </ProjectCard>
                        </ProjectCardWrapper>
                    );
                })}
            </ProjectGrid>
        </Container>
        </>
    );
};

export default FD10025Winners;